/* 2026-11-02 テスト T04 の直し：前の方のご依頼主の情報を出さない
   入力画面（ksv-order.js）は、同じタブの間だけ sessionStorage「ksv_order_v1」にご依頼主などを控えている。
   ・カートが空のページを開いたとき（＝ご注文が終わったあと・最初から）→ 控えを消す
   ・ログイン／ログアウトで人が変わったとき → 控えを消し、カートに残ったご依頼主（_ms_orderer）も使わない
   ksv-order.js より先に読み込まれる（snippets/ksv-lead.liquid の defer の順番）。消せば元どおり */
(function () {
  var s = document.currentScript;
  if (!s) return;
  var who = s.getAttribute('data-who') || 'g';
  var empty = s.getAttribute('data-empty') === '1';
  var K = 'ksv_order_v1', W = 'ksv_order_who', prev = null;
  try { prev = sessionStorage.getItem(W); } catch (e) {}
  var changed = prev !== null && prev !== who;
  try {
    if (empty || changed) sessionStorage.removeItem(K);
    sessionStorage.setItem(W, who);
  } catch (e) {}
  if (changed) {
    var el = document.querySelector('[data-ms-data]');
    if (el) {
      try { var d = JSON.parse(el.textContent); d.orderer = ''; el.textContent = JSON.stringify(d); } catch (e) {}
    }
  }
})();
